export const aliasRegex = /^[a-zA-Z0-9._-]{3,64}$/;
